var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91743 7.9165L1.48687 5.48595C1.21604 5.21511 0.785482 5.21511 0.514648 5.48595C0.243815 5.75678 0.243815 6.18734 0.514648 6.45817L3.42437 9.36789C3.6952 9.63872 4.1327 9.63872 4.40354 9.36789L11.7646 2.01373C12.0355 1.74289 12.0355 1.31234 11.7646 1.0415C11.4938 0.770671 11.0633 0.770671 10.7924 1.0415L3.91743 7.9165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.511cda8c.svg";
export { ForwardRef as ReactComponent };